import React, { useState } from "react";
import { Container } from "..";
import { Accordion } from "../../../../../app/components";
import CustomCell from "../../../../../app/components/custom.tables.components/custom.cell";
import CustomRow from "../../../../../app/components/custom.tables.components/custom.row";
import EditNotesInput from "../edit.notes.input";
import CustomTooltip from "../../../../../app/components/tooltip/custom.tooltip";
import { useRestoreTableVisibility } from "../../hooks/useRestoreTableVisibility";
import { DATA_TABLE_NAME } from "../../constants";
import { toParticipantUiText } from "../../../../../app/utils/participantTerminology";

export default function EPriceInfoTable({ data, readOnly }) {
  const [editState, setEditState] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);

  useRestoreTableVisibility('EPriceInfoTable', setIsExpanded);

  const headerData = [
    { width: "30%", textAlign: "right", label: "" },
    { width: "10%", label: "Visit Sampling SDR/SDV Time (reduced SDR/SDV)" },
    { width: "10%", label: "100% SDR/SDV" },
    {
      width: "10%",
      label: "Data Review (CDA): KRI Review and Study Level Reporting Only",
    },
    { width: "10%", label: "SDR/SDV % Participant Visits" },
    { width: "30%", label: "Notes" },
  ];

  const renderHeader = () => (
    <CustomRow>
      {headerData.map((col, idx) => (
        <CustomCell
          key={idx}
          variant="header"
          justify={col.textAlign ? col.textAlign : undefined}
          width={col.width}
          style={col.textAlign ? { borderBottom: "none" } : {}}
        >
          {col.label}
        </CustomCell>
      ))}
    </CustomRow>
  );

  const renderRows = () => {
    return data.map((d, idx) => {
      return (
        <CustomRow key={d.rowLabel || `row-${idx}`}>
          <CustomCell
            variant="header"
            justify="flex-end"
            width={headerData[0].width}
            style={{
              borderBottom: "none",
            }}
            textAlign="right"
          >
            {toParticipantUiText(d.rowLabel)}
          </CustomCell>
          <CustomCell width={headerData[1].width}>
            <CustomTooltip title={d.cellValue1?.toString() || ''}>
              <div>{d.cellValue1}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width={headerData[2].width}>
            <CustomTooltip title={d.cellValue2?.toString() || ''}>
              <div>{d.cellValue2}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width={headerData[3].width}>
            <CustomTooltip title={d.cellValue3?.toString() || ''}>
              <div>{d.cellValue3}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width={headerData[4].width}>
            <CustomTooltip title={d.cellValue4?.toString() || ''}>
              <div>{d.cellValue4}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell
            style={{
              position: "relative",
            }}
            textAlign="left"
            justify="flex-start"
            width={headerData[5].width}
          >
            <EditNotesInput
              d={d}
              editState={editState}
              setEditState={setEditState}
              readOnly={readOnly}
            />
          </CustomCell>
        </CustomRow>
      );
    });
  };

  return (
    <Accordion
      scrollIntoView={true}
      width={"100%"}
      summary={"ePrice Info"}
      defaultExpanded={isExpanded}
      onChange={(e, expanded) => setIsExpanded(expanded)}
      data-table-name={DATA_TABLE_NAME.EPRICE_INFO_TABLE}
    >
      <Container 
        onClick={(e) => e.stopPropagation()} 
        data-table-name={DATA_TABLE_NAME.EPRICE_INFO_TABLE}
        data-table-container="true"
      >
        {renderHeader()}
        {renderRows()}
      </Container>
    </Accordion>
  );
}
